import AsyncState from "react-async-stateful";

import * as UserSelectors from "../User/User.selector";
import * as FleetSelectors from "../Fleet/Fleet.selector";
import * as GroupUtils from "../../lib/util/GroupUtils";

import { asyncStateProxy, createSelector } from "../../lib/util/ReduxUtils";
import { selectLoggedInUserGroupId } from "../User/User.selector";
import { selectCurrentScopeFleetGroups } from "../Fleet/Fleet.selector";
import { StoreState } from "../RootReducer";
import { Group } from "../../lib/types/Group";
import { isManagerOrBelow } from "../../lib/util/AuthUtils";
import { isDemoModeEnabled } from "../Global/Global.selector";

export const selectIsCurrentScopeDriverless = createSelector(
	[
		FleetSelectors.selectCurrentScopeFleet,
		UserSelectors.selectIsCurrentScopeFleetOutsider,
	],
	(fleet, guestMode) => (fleet.value && fleet.value.driverless) || guestMode,
);

export const selectCurrentScopeGroupsAvailableToUser = (
	state: StoreState,
): AsyncState<Group[]> => {
	return asyncStateProxy(selectCurrentScopeFleetGroups(state), (allGroups) => {
		const userGroup = selectLoggedInUserGroupId(state);
		const user = UserSelectors.selectLoggedInUser(state);
		const userAccessGroup = user?.accessGroup;
		const scoped = userGroup && isManagerOrBelow() && !isDemoModeEnabled(state);

		if (!scoped) {
			return allGroups;
		}

		const scopedGroup =
			scoped && GroupUtils.findGroupById(allGroups as any, userGroup);

		if (!scopedGroup) {
			return allGroups;
		}

		if (userAccessGroup && userAccessGroup !== userGroup) {
			const accessGroup = GroupUtils.findGroupById(
				allGroups as any,
				userAccessGroup,
			);
			if (accessGroup) {
				return [accessGroup];
			}
		}

		return [scopedGroup];
	}) as any;
};
